import {ParametryInnegoPrzedmiotu, Uszkodzenie} from '../../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StrategiaComponent} from './strategia.component';
import {SlownikUszkodzen} from '../../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';

@Component({
  templateUrl: './strategia-inne.component.html'
})
export class StrategiaInneComponent implements StrategiaComponent {

  private MAX_LENGTH = 40;

  @Input()
  slownikUszkodzen!: SlownikUszkodzen;

  @Input()
  uszkodzenie!: Uszkodzenie<ParametryInnegoPrzedmiotu>;

  @Output()
  public usunUszkodzenieClick = new EventEmitter<{identyfikatorUszkodzenia: string}>()

  usunUszkodzenie(event: {identyfikatorUszkodzenia: string}): void {
    this.usunUszkodzenieClick.emit(event)
  }

  getOpis(): string {
    return this.uszkodzenie.parametry.komentarz.length > this.MAX_LENGTH ?
      this.uszkodzenie.parametry.komentarz.substr(0, this.MAX_LENGTH) + '...' :
      this.uszkodzenie.parametry.komentarz;
  }
}
